import React from 'react'
import styled from 'styled-components'
import Finwhale_warranty from '../static/docs/Finwhale_warranty.pdf'
import * as media from '../media'
import {browserHistory} from 'react-router'
import TranslateText from 'src/text/modal';
import CurrentLanguageContext from 'src/context/currentLanguageContext';

const Foot = styled.footer`
  padding: 9px 0;
  line-height: 24px;
  color: #919191;
  display: flex;
  justify-content: space-around;
  margin-left: 10%;
  margin-right: 10%;

  & a {
    text-decoration: underline;
    color: #919191;
  }

  & a:hover {
    color: #0054ff;
  }
  
  .policy {
    margin-left: auto;
  }
  
  .item {
    margin-left: 20px;
  }
  
  ${media.smallerThan(1001)`
    flex-direction: column;
    margin-left: 0;
    margin-right: 0;
    text-align: center;
    
    .disclosure {
      color: #414141;
      margin-top: 20px;
      margin-bottom: 20px;
    }
      
    .policy {
      margin-left: 0;
    }
    
    .item {
      margin-left: 0;
    }
  `}
`

const Footer = () => (
    <CurrentLanguageContext.Consumer>
        {currentLanguage => {
            return <Foot>
                <span className="disclosure">© 2020 Grunntech</span>
                <a
                    style={{cursor: 'pointer'}}
                    onClick={() => {
                        browserHistory.push('/policy')
                    }}
                    className="policy"
                >
                    <TranslateText id="footer__politic_info2" style={{ display: 'inline' }} />
                </a>
                <a target="_blank" className="item" href={currentLanguage !== 'ua' ? Finwhale_warranty : ''}>
                    <TranslateText id="footer__warranty_terms" style={{ display: 'inline' }} />
                </a>
            </Foot>
        }}
    </CurrentLanguageContext.Consumer>

)

export default Footer



// WEBPACK FOOTER //
// ./src/finwhale/footer.js